// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 9774) return "static/chunks/framework-6d0b56c68ee4ba37.js";
	if (chunkId === 742) return "static/chunks/742-edd7133b7b7c207f.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"593":"a7bce429730ed526","4395":"f4b807778ec9f615","7210":"b250749ca8827065"}[chunkId] + ".js";
};